/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.9.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivateCollectorLicense201Response,
  ActivateCollectorLicense401Response,
  ActivateCollectorLicense403Response,
  ActivateCollectorLicense500Response,
  ActivateCollectorLicenseRequest,
  AddClientTeamMember200ResponseInner,
  AddClientTeamMemberRequest,
  CheckUpdate200Response,
  CreateClientAsAdmin200Response,
  CreateClientAsAdmin201Response,
  CreateClientAsAdmin400Response,
  CreateClientAsAdmin401Response,
  CreateClientAsAdmin402Response,
  CreateClientRequest,
  CreateNewQuickcheckClientRequest,
  GetAllIoes200Response,
  GetClientLicense200Response,
  GetClientTeam200ResponseInner,
  GetClientTeammember200Response,
  GetCollectorHealthStatus200Response,
  GetCollectorLicense200Response,
  GetCollectorLicense401Response,
  GetCollectorLicense404Response,
  GetCollectorLicense500Response,
  GetContactDetails200Response,
  GetEntraMeta200Response,
  GetInstallerLicense200Response,
  GetInstallerLicense500Response,
  InitialScanRequest,
  RemoveClientTeamMemberRequest,
  SaveEntraMetaRequest,
  SetContactDetailsRequest,
  SetEmployeeCountRequest,
  UpdateIoeRequest,
} from '../models/index';
import {
    ActivateCollectorLicense201ResponseFromJSON,
    ActivateCollectorLicense201ResponseToJSON,
    ActivateCollectorLicense401ResponseFromJSON,
    ActivateCollectorLicense401ResponseToJSON,
    ActivateCollectorLicense403ResponseFromJSON,
    ActivateCollectorLicense403ResponseToJSON,
    ActivateCollectorLicense500ResponseFromJSON,
    ActivateCollectorLicense500ResponseToJSON,
    ActivateCollectorLicenseRequestFromJSON,
    ActivateCollectorLicenseRequestToJSON,
    AddClientTeamMember200ResponseInnerFromJSON,
    AddClientTeamMember200ResponseInnerToJSON,
    AddClientTeamMemberRequestFromJSON,
    AddClientTeamMemberRequestToJSON,
    CheckUpdate200ResponseFromJSON,
    CheckUpdate200ResponseToJSON,
    CreateClientAsAdmin200ResponseFromJSON,
    CreateClientAsAdmin200ResponseToJSON,
    CreateClientAsAdmin201ResponseFromJSON,
    CreateClientAsAdmin201ResponseToJSON,
    CreateClientAsAdmin400ResponseFromJSON,
    CreateClientAsAdmin400ResponseToJSON,
    CreateClientAsAdmin401ResponseFromJSON,
    CreateClientAsAdmin401ResponseToJSON,
    CreateClientAsAdmin402ResponseFromJSON,
    CreateClientAsAdmin402ResponseToJSON,
    CreateClientRequestFromJSON,
    CreateClientRequestToJSON,
    CreateNewQuickcheckClientRequestFromJSON,
    CreateNewQuickcheckClientRequestToJSON,
    GetAllIoes200ResponseFromJSON,
    GetAllIoes200ResponseToJSON,
    GetClientLicense200ResponseFromJSON,
    GetClientLicense200ResponseToJSON,
    GetClientTeam200ResponseInnerFromJSON,
    GetClientTeam200ResponseInnerToJSON,
    GetClientTeammember200ResponseFromJSON,
    GetClientTeammember200ResponseToJSON,
    GetCollectorHealthStatus200ResponseFromJSON,
    GetCollectorHealthStatus200ResponseToJSON,
    GetCollectorLicense200ResponseFromJSON,
    GetCollectorLicense200ResponseToJSON,
    GetCollectorLicense401ResponseFromJSON,
    GetCollectorLicense401ResponseToJSON,
    GetCollectorLicense404ResponseFromJSON,
    GetCollectorLicense404ResponseToJSON,
    GetCollectorLicense500ResponseFromJSON,
    GetCollectorLicense500ResponseToJSON,
    GetContactDetails200ResponseFromJSON,
    GetContactDetails200ResponseToJSON,
    GetEntraMeta200ResponseFromJSON,
    GetEntraMeta200ResponseToJSON,
    GetInstallerLicense200ResponseFromJSON,
    GetInstallerLicense200ResponseToJSON,
    GetInstallerLicense500ResponseFromJSON,
    GetInstallerLicense500ResponseToJSON,
    InitialScanRequestFromJSON,
    InitialScanRequestToJSON,
    RemoveClientTeamMemberRequestFromJSON,
    RemoveClientTeamMemberRequestToJSON,
    SaveEntraMetaRequestFromJSON,
    SaveEntraMetaRequestToJSON,
    SetContactDetailsRequestFromJSON,
    SetContactDetailsRequestToJSON,
    SetEmployeeCountRequestFromJSON,
    SetEmployeeCountRequestToJSON,
    UpdateIoeRequestFromJSON,
    UpdateIoeRequestToJSON,
} from '../models/index';

export interface ActivateCollectorLicenseOperationRequest {
    clientUUID: string;
    activateCollectorLicenseRequest?: ActivateCollectorLicenseRequest;
}

export interface AddClientTeamMemberOperationRequest {
    clientUUID: string;
    addClientTeamMemberRequest?: AddClientTeamMemberRequest;
}

export interface CalculateSecurityScoreRequest {
    clientUUID: string;
}

export interface CancelSubscriptionRequest {
    clientUUID: string;
}

export interface CheckUpdateRequest {
    clientUUID: string;
}

export interface CreateClientOperationRequest {
    createClientRequest: CreateClientRequest;
}

export interface CreateNewQuickcheckClientOperationRequest {
    createNewQuickcheckClientRequest?: CreateNewQuickcheckClientRequest;
}

export interface DeleteClientRequest {
    clientUUID: string;
}

export interface DownloadPubCertRequest {
    clientUUID: string;
}

export interface GetAllIoesRequest {
    clientUUID: string;
}

export interface GetClientLicenseRequest {
    clientUUID: string;
}

export interface GetClientReportRequest {
    clientUUID: string;
}

export interface GetClientTeamRequest {
    clientUUID: string;
}

export interface GetClientTeammemberRequest {
    clientUUID: string;
    userUUID: string;
}

export interface GetCollectorAuditStatusRequest {
    clientUUID: string;
}

export interface GetCollectorConfigRequest {
    clientUUID: string;
}

export interface GetCollectorHealthStatusRequest {
    clientUUID: string;
}

export interface GetCollectorLicenseRequest {
    clientUUID: string;
    activateCollectorLicenseRequest?: ActivateCollectorLicenseRequest;
}

export interface GetContactDetailsRequest {
    clientUUID: string;
}

export interface GetEntraMetaRequest {
    clientUUID: string;
}

export interface GetInstallerRequest {
    clientUUID: string;
}

export interface GetInstallerLicenseRequest {
    clientUUID: string;
}

export interface GetQuickcheckInstallerRequest {
    clientUUID: string;
}

export interface GetVersionRequest {
    clientUUID: string;
}

export interface InitialScanOperationRequest {
    clientUUID: string;
    initialScanRequest?: InitialScanRequest;
}

export interface RemoveClientTeamMemberOperationRequest {
    clientUUID: string;
    removeClientTeamMemberRequest: RemoveClientTeamMemberRequest;
}

export interface ResetIoaThresholdsRequest {
    clientUUID: string;
}

export interface ResetIoeCriticalitiesRequest {
    clientUUID: string;
}

export interface ResetIoeThresholdsRequest {
    clientUUID: string;
}

export interface SaveEntraMetaOperationRequest {
    clientUUID: string;
    saveEntraMetaRequest?: SaveEntraMetaRequest;
}

export interface SendFileLogRequest {
    clientUUID: string;
    logName: string;
}

export interface SetContactDetailsOperationRequest {
    clientUUID: string;
    setContactDetailsRequest?: SetContactDetailsRequest;
}

export interface SetEmployeeCountOperationRequest {
    clientUUID: string;
    setEmployeeCountRequest?: SetEmployeeCountRequest;
}

export interface UpdateIoeOperationRequest {
    clientUUID: string;
    ioeId: string;
    updateIoeRequest?: UpdateIoeRequest;
}

export interface ValidateEntraConnectionRequest {
    clientUUID: string;
}

/**
 * 
 */
export class ClientApi extends runtime.BaseAPI {

    /**
     * Get client license with data for collector
     */
    async activateCollectorLicenseRaw(requestParameters: ActivateCollectorLicenseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivateCollectorLicense201Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling activateCollectorLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/collector/license/activate`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateCollectorLicenseRequestToJSON(requestParameters['activateCollectorLicenseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivateCollectorLicense201ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license with data for collector
     */
    async activateCollectorLicense(clientUUID: string, activateCollectorLicenseRequest?: ActivateCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivateCollectorLicense201Response> {
        const response = await this.activateCollectorLicenseRaw({ clientUUID: clientUUID, activateCollectorLicenseRequest: activateCollectorLicenseRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Get add new member to client team
     */
    async addClientTeamMemberRaw(requestParameters: AddClientTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AddClientTeamMember200ResponseInner>>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling addClientTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/collaboration/team`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddClientTeamMemberRequestToJSON(requestParameters['addClientTeamMemberRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AddClientTeamMember200ResponseInnerFromJSON));
    }

    /**
     * Get add new member to client team
     */
    async addClientTeamMember(clientUUID: string, addClientTeamMemberRequest?: AddClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AddClientTeamMember200ResponseInner>> {
        const response = await this.addClientTeamMemberRaw({ clientUUID: clientUUID, addClientTeamMemberRequest: addClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Trigger security calculation for client
     */
    async calculateSecurityScoreRaw(requestParameters: CalculateSecurityScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling calculateSecurityScore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/ioe/security-score`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Trigger security calculation for client
     */
    async calculateSecurityScore(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.calculateSecurityScoreRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Cancel subscription for client
     */
    async cancelSubscriptionRaw(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling cancelSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/license/cancel`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Cancel subscription for client
     */
    async cancelSubscription(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.cancelSubscriptionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Check if there is an update available for the collector
     */
    async checkUpdateRaw(requestParameters: CheckUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUpdate200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling checkUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/update`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckUpdate200ResponseFromJSON(jsonValue));
    }

    /**
     * Check if there is an update available for the collector
     */
    async checkUpdate(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUpdate200Response> {
        const response = await this.checkUpdateRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new client
     */
    async createClientRaw(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['createClientRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientRequest',
                'Required parameter "createClientRequest" was null or undefined when calling createClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientRequestToJSON(requestParameters['createClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new client
     */
    async createClient(createClientRequest: CreateClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.createClientRaw({ createClientRequest: createClientRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create new quickcheck client
     */
    async createNewQuickcheckClientRaw(requestParameters: CreateNewQuickcheckClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/quickcheck/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNewQuickcheckClientRequestToJSON(requestParameters['createNewQuickcheckClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Create new quickcheck client
     */
    async createNewQuickcheckClient(createNewQuickcheckClientRequest?: CreateNewQuickcheckClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.createNewQuickcheckClientRaw({ createNewQuickcheckClientRequest: createNewQuickcheckClientRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete client
     */
    async deleteClientRaw(requestParameters: DeleteClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling deleteClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete client
     */
    async deleteClient(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.deleteClientRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Download public entra cert
     */
    async downloadPubCertRaw(requestParameters: DownloadPubCertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling downloadPubCert().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/entra/certificate/public`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download public entra cert
     */
    async downloadPubCert(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadPubCertRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Get all IOEs for client
     */
    async getAllIoesRaw(requestParameters: GetAllIoesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllIoes200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getAllIoes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/ioe/states`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllIoes200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all IOEs for client
     */
    async getAllIoes(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllIoes200Response> {
        const response = await this.getAllIoesRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get client license
     */
    async getClientLicenseRaw(requestParameters: GetClientLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientLicense200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/license`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license
     */
    async getClientLicense(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientLicense200Response> {
        const response = await this.getClientLicenseRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get client report pdf
     */
    async getClientReportRaw(requestParameters: GetClientReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/report`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get client report pdf
     */
    async getClientReport(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClientReportRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Get client team members
     */
    async getClientTeamRaw(requestParameters: GetClientTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClientTeam200ResponseInner>>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collaboration/team`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClientTeam200ResponseInnerFromJSON));
    }

    /**
     * Get client team members
     */
    async getClientTeam(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClientTeam200ResponseInner>> {
        const response = await this.getClientTeamRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get team member
     */
    async getClientTeammemberRaw(requestParameters: GetClientTeammemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientTeammember200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getClientTeammember().'
            );
        }

        if (requestParameters['userUUID'] == null) {
            throw new runtime.RequiredError(
                'userUUID',
                'Required parameter "userUUID" was null or undefined when calling getClientTeammember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collaboration/team/member/{userUUID}`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))).replace(`{${"userUUID"}}`, encodeURIComponent(String(requestParameters['userUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientTeammember200ResponseFromJSON(jsonValue));
    }

    /**
     * Get team member
     */
    async getClientTeammember(clientUUID: string, userUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientTeammember200Response> {
        const response = await this.getClientTeammemberRaw({ clientUUID: clientUUID, userUUID: userUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get current audit status as string - displayed during scan
     */
    async getCollectorAuditStatusRaw(requestParameters: GetCollectorAuditStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitialScanRequest>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorAuditStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/audit/status`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitialScanRequestFromJSON(jsonValue));
    }

    /**
     * Get current audit status as string - displayed during scan
     */
    async getCollectorAuditStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitialScanRequest> {
        const response = await this.getCollectorAuditStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get collector config as prep for selfhosted instances
     */
    async getCollectorConfigRaw(requestParameters: GetCollectorConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/config`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get collector config as prep for selfhosted instances
     */
    async getCollectorConfig(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCollectorConfigRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get collector health status - Determines if collector should be restarted by scheduled task
     */
    async getCollectorHealthStatusRaw(requestParameters: GetCollectorHealthStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollectorHealthStatus200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorHealthStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/health`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollectorHealthStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Get collector health status - Determines if collector should be restarted by scheduled task
     */
    async getCollectorHealthStatus(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollectorHealthStatus200Response> {
        const response = await this.getCollectorHealthStatusRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get client license with data for collector
     */
    async getCollectorLicenseRaw(requestParameters: GetCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollectorLicense200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getCollectorLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/collector/license`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateCollectorLicenseRequestToJSON(requestParameters['activateCollectorLicenseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollectorLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license with data for collector
     */
    async getCollectorLicense(clientUUID: string, activateCollectorLicenseRequest?: ActivateCollectorLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollectorLicense200Response> {
        const response = await this.getCollectorLicenseRaw({ clientUUID: clientUUID, activateCollectorLicenseRequest: activateCollectorLicenseRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Get client contact details
     */
    async getContactDetailsRaw(requestParameters: GetContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactDetails200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/contact`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Get client contact details
     */
    async getContactDetails(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactDetails200Response> {
        const response = await this.getContactDetailsRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get Entra ID settings
     */
    async getEntraMetaRaw(requestParameters: GetEntraMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEntraMeta200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getEntraMeta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/entra/data`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEntraMeta200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Entra ID settings
     */
    async getEntraMeta(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEntraMeta200Response> {
        const response = await this.getEntraMetaRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get installer with config as file, used from dashboard
     */
    async getInstallerRaw(requestParameters: GetInstallerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getInstaller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/installer`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get installer with config as file, used from dashboard
     */
    async getInstaller(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getInstallerRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Get client license with data for installer
     */
    async getInstallerLicenseRaw(requestParameters: GetInstallerLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInstallerLicense200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getInstallerLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/installer/license`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInstallerLicense200ResponseFromJSON(jsonValue));
    }

    /**
     * Get client license with data for installer
     */
    async getInstallerLicense(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInstallerLicense200Response> {
        const response = await this.getInstallerLicenseRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get quickcheck installer with config as file, used from email
     */
    async getQuickcheckInstallerRaw(requestParameters: GetQuickcheckInstallerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getQuickcheckInstaller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/quickcheck/collector/installer`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get quickcheck installer with config as file, used from email
     */
    async getQuickcheckInstaller(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getQuickcheckInstallerRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Check if there is an update available for the collector in dashboard
     */
    async getVersionRaw(requestParameters: GetVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUpdate200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/version`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckUpdate200ResponseFromJSON(jsonValue));
    }

    /**
     * Check if there is an update available for the collector in dashboard
     */
    async getVersion(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUpdate200Response> {
        const response = await this.getVersionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Report status of initial scan
     */
    async initialScanRaw(requestParameters: InitialScanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling initialScan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/collector/initialscan`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitialScanRequestToJSON(requestParameters['initialScanRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Report status of initial scan
     */
    async initialScan(clientUUID: string, initialScanRequest?: InitialScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.initialScanRaw({ clientUUID: clientUUID, initialScanRequest: initialScanRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Remove client team member
     */
    async removeClientTeamMemberRaw(requestParameters: RemoveClientTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling removeClientTeamMember().'
            );
        }

        if (requestParameters['removeClientTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'removeClientTeamMemberRequest',
                'Required parameter "removeClientTeamMemberRequest" was null or undefined when calling removeClientTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/collaboration/team`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveClientTeamMemberRequestToJSON(requestParameters['removeClientTeamMemberRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove client team member
     */
    async removeClientTeamMember(clientUUID: string, removeClientTeamMemberRequest: RemoveClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.removeClientTeamMemberRaw({ clientUUID: clientUUID, removeClientTeamMemberRequest: removeClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Reset all IoAs thresholds for client
     */
    async resetIoaThresholdsRaw(requestParameters: ResetIoaThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoaThresholds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/ioa/thresholds/reset`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset all IoAs thresholds for client
     */
    async resetIoaThresholds(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoaThresholdsRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Reset all IOEs criticalities for client
     */
    async resetIoeCriticalitiesRaw(requestParameters: ResetIoeCriticalitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoeCriticalities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/ioe/criticalities/reset`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset all IOEs criticalities for client
     */
    async resetIoeCriticalities(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoeCriticalitiesRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Reset all IOEs thresholds for client
     */
    async resetIoeThresholdsRaw(requestParameters: ResetIoeThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling resetIoeThresholds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/ioe/thresholds/reset`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset all IOEs thresholds for client
     */
    async resetIoeThresholds(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetIoeThresholdsRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Save Entra ID settings
     */
    async saveEntraMetaRaw(requestParameters: SaveEntraMetaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling saveEntraMeta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/entra/data`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveEntraMetaRequestToJSON(requestParameters['saveEntraMetaRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save Entra ID settings
     */
    async saveEntraMeta(clientUUID: string, saveEntraMetaRequest?: SaveEntraMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveEntraMetaRaw({ clientUUID: clientUUID, saveEntraMetaRequest: saveEntraMetaRequest }, initOverrides);
    }

    /**
     * Upload log files to client (used for debugging) for collector
     */
    async sendFileLogRaw(requestParameters: SendFileLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling sendFileLog().'
            );
        }

        if (requestParameters['logName'] == null) {
            throw new runtime.RequiredError(
                'logName',
                'Required parameter "logName" was null or undefined when calling sendFileLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/collector/log/{logName}`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))).replace(`{${"logName"}}`, encodeURIComponent(String(requestParameters['logName']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload log files to client (used for debugging) for collector
     */
    async sendFileLog(clientUUID: string, logName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.sendFileLogRaw({ clientUUID: clientUUID, logName: logName }, initOverrides);
        return await response.value();
    }

    /**
     * Update client contact details
     */
    async setContactDetailsRaw(requestParameters: SetContactDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/contact`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetContactDetailsRequestToJSON(requestParameters['setContactDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update client contact details
     */
    async setContactDetails(clientUUID: string, setContactDetailsRequest?: SetContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setContactDetailsRaw({ clientUUID: clientUUID, setContactDetailsRequest: setContactDetailsRequest }, initOverrides);
    }

    /**
     * Set employee count for client
     */
    async setEmployeeCountRaw(requestParameters: SetEmployeeCountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setEmployeeCount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/employeeCount`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetEmployeeCountRequestToJSON(requestParameters['setEmployeeCountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Set employee count for client
     */
    async setEmployeeCount(clientUUID: string, setEmployeeCountRequest?: SetEmployeeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.setEmployeeCountRaw({ clientUUID: clientUUID, setEmployeeCountRequest: setEmployeeCountRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update IoE
     */
    async updateIoeRaw(requestParameters: UpdateIoeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling updateIoe().'
            );
        }

        if (requestParameters['ioeId'] == null) {
            throw new runtime.RequiredError(
                'ioeId',
                'Required parameter "ioeId" was null or undefined when calling updateIoe().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/client/{clientUUID}/ioe/{ioeId}`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))).replace(`{${"ioeId"}}`, encodeURIComponent(String(requestParameters['ioeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIoeRequestToJSON(requestParameters['updateIoeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Update IoE
     */
    async updateIoe(clientUUID: string, ioeId: string, updateIoeRequest?: UpdateIoeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.updateIoeRaw({ clientUUID: clientUUID, ioeId: ioeId, updateIoeRequest: updateIoeRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Validate Entra ID connection
     */
    async validateEntraConnectionRaw(requestParameters: ValidateEntraConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling validateEntraConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/client/{clientUUID}/entra/validate`.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin200ResponseFromJSON(jsonValue));
    }

    /**
     * Validate Entra ID connection
     */
    async validateEntraConnection(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin200Response> {
        const response = await this.validateEntraConnectionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

}
